import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";
import DataTableCheckbox from "./DataTableCheckbox";
import { alignClass, cx, justifyClass } from "./utils";

const ARIA_SORT = { asc: "ascending", desc: "descending" };

export default function DataTableHeader({
  columns,
  sort,
  onSort,
  selectable,
  allSelected,
  someSelected,
  onToggleAll,
  selectAllDisabled,
  stickyHeader,
  labels,
}) {
  const thBase = cx(
    "bg-app-table-header px-4 py-3 text-xs font-semibold uppercase tracking-wide text-app-muted whitespace-nowrap shadow-[inset_0_-1px_0_var(--border-primary)]",
    stickyHeader && "sticky top-0 z-[1]",
  );

  return (
    <thead>
      <tr>
        {selectable && (
          <th scope="col" className={cx(thBase, "w-12 pr-0")}>
            <DataTableCheckbox
              checked={allSelected}
              indeterminate={someSelected}
              onChange={onToggleAll}
              disabled={selectAllDisabled}
              aria-label={labels.selectAll}
            />
          </th>
        )}

        {columns.map((column) => {
          const align = column.align || "left";
          const direction = sort?.key === column.key ? sort.direction : null;
          const SortIcon = direction === "asc" ? ArrowUp : direction === "desc" ? ArrowDown : ChevronsUpDown;

          return (
            <th
              key={column.key}
              scope="col"
              aria-sort={column.sortable ? ARIA_SORT[direction] || "none" : undefined}
              style={column.width ? { width: column.width, minWidth: column.width } : undefined}
              className={cx(thBase, alignClass[align], column.headerClassName)}
            >
              {column.sortable ? (
                <button
                  type="button"
                  onClick={() => onSort(column.key)}
                  className={cx(
                    "group -mx-1.5 inline-flex items-center gap-1.5 rounded-md px-1.5 py-0.5 uppercase tracking-wide transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40",
                    justifyClass[align],
                    direction ? "text-app-primary" : "hover:text-app-primary",
                  )}
                >
                  {column.label}
                  <SortIcon
                    size={14}
                    strokeWidth={2}
                    aria-hidden="true"
                    className={cx(
                      "shrink-0 transition-colors",
                      direction ? "text-blue-600 dark:text-blue-400" : "text-app-muted opacity-60 group-hover:opacity-100",
                    )}
                  />
                </button>
              ) : (
                column.label
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  );
}
